import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Table, Form } from 'react-bootstrap';
import ButtonStyle from '../util/ButtonStyle';
import Draggable from 'react-draggable';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SelectCenter from "../util/SelectCenter";
import { confirmAlert } from 'react-confirm-alert';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import format from 'date-fns/format';
import ko from 'date-fns/locale/ko';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { addDays, subDays } from 'date-fns'
import GetApiHost from '../util/GetApiHost';
registerLocale('ko', ko)

function NewGatePopup(props) {
    const options = [
        { value : 'Y', label : '사용' },
        { value : 'N', label : '사용 안함' }
    ]

    const gubunOptions = [
        { value : '일', label : '일' },
        { value : '월', label : '월' },
        { value : '화', label : '화' },
        { value : '수', label : '수' },
        { value : '목', label : '목' },
        { value : '금', label : '금' },
        { value : '토', label : '토' },
        { value : '휴일', label : '휴일' }
    ]
    const [cid, setCid] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [startTime1, setStartTime1] = useState('00');
    const [startTime2, setStartTime2] = useState('00');
    const [endTime1, setEndTime1] = useState('23');
    const [endTime2, setEndTime2] = useState('59');
    const [gubun, setGubun] = useState(gubunOptions[0]);
    const [offDayShow, setOffDayShow] = useState(false);
    const [state, setState] = useState(options[0]);
    const [selectedCenter, setSelectedCenter] = useState('');
    const [title, setTitle] = useState('');
    const data = useSelector(state => state.data);
    const api_host = GetApiHost();

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
    }

    function handleStartChange(date) {
        setStartDate(date)
    }

    function handleGubunChange(selectedOption){
        setGubun(selectedOption)
        if(selectedOption.value === '휴일'){
            setOffDayShow(true)
        }else{
            setOffDayShow(false)
        }
    }

    function handleStateChange(selectedOption){
        setState(selectedOption)
    }

    function handleStartDatePlus(){
        if(startDate){
            setStartDate(addDays(startDate, 1))
        }
    }

    function handleStartDateMinus(){
        if(startDate){
            setStartDate(subDays(startDate, 1))
        }
    }

    // gate 추가 및 복사
    function handleSubmit () {
        (async function () {
            if(!selectedCenter){
                alert("센터를 선택해 주세요.")
                return false;
            }
            if(gubun.value === '휴일'){
                if(!startDate){
                    alert("휴일 날짜를 선택해 주세요.")
                    return false;
                }
            }else{
                if(!startTime1){
                    alert("시작 시간을 입력해 주세요.")
                    return false;
                }
                if(!startTime2){
                    alert("시작 시간을 입력해 주세요.")
                    return false;
                }
                if(!endTime1){
                    alert("종료 시간을 입력해 주세요.")
                    return false;
                }
                if(!endTime2){
                    alert("종료 시간을 입력해 주세요.")
                    return false;
                }
            }

            var temp_cid = '';
            if(data.cid !== 'root'){
                temp_cid = data.cid
            }else{
                temp_cid = selectedCenter
            }

            let startTime = startTime1 + ":" + startTime2;
            let endTime = endTime1 + ":" + endTime2;

            const result = await axios.post(api_host + '/admin/add_gate_info', {
                cid : temp_cid,
                yoil : gubun.value,
                off_day : moment(startDate).format('YYYY-MM-DD'),
                open : startTime,
                close : endTime,
                state : state.value
            })
            if(result.data.ret == 'Y'){
                alert("완료되었습니다.");
                props.closePopup("updated");
            }else{
                alert(result.data.msg)
            }
        })();
    }

    function handleEdit () {
        (async function () {
            if(!selectedCenter){
                alert("센터를 선택해 주세요.")
                return false;
            }
            if(gubun.value === '휴일'){
                if(!startDate){
                    alert("휴일 날짜를 선택해 주세요.")
                    return false;
                }
            }else{
                if(!startTime1){
                    alert("시작 시간을 입력해 주세요.")
                    return false;
                }
                if(!startTime2){
                    alert("시작 시간을 입력해 주세요.")
                    return false;
                }
                if(!endTime1){
                    alert("종료 시간을 입력해 주세요.")
                    return false;
                }
                if(!endTime2){
                    alert("종료 시간을 입력해 주세요.")
                    return false;
                }
            }

            var temp_cid = '';
            if(data.cid !== 'root'){
                temp_cid = data.cid
            }else{
                temp_cid = selectedCenter
            }

            let startTime = startTime1 + ":" + startTime2;
            let endTime = endTime1 + ":" + endTime2;

            const result = await axios.post(api_host + '/admin/edit_gate_info', {
                seq : props.data.seq,
                cid : temp_cid,
                yoil : gubun.value,
                off_day : moment(startDate).format('YYYY-MM-DD'),
                open : startTime,
                close : endTime,
                state : state.value
            })
            if(result.data.ret == 'Y'){
                alert("완료되었습니다.");
                props.closePopup("updated");
            }else{
                alert(result.data.msg)
            }
        })();
    }

    function deleteGate(seq) {
        (async function () {
            const result = await axios.post(api_host + '/admin/delete_gate_info', {
                seq : props.data.seq
            })
            if(result.data.ret == 'Y'){
                alert("완료되었습니다.");
                props.closePopup("updated");
            }else{
                alert(result.data.msg)
            }
        })();
    }

    function handleDelete() {
        confirmAlert({
            title: '삭제 확인',
            message: "잠금 정보를 삭제하시겠습니까?",
            buttons: [
              {
                label: 'Yes',
                onClick: () => deleteGate(props.data.seq)
              },
              {
                label: 'No'
              }
            ]
          });
    }

    useEffect(()=>{
        if(props.mode === "add"){
            setTitle("시간설정 추가");
        }else if(props.mode === "edit"){
            console.log(props.data);
            setCid(props.data.cid);
            setTitle("시간설정 수정");
            gubunOptions.map((item, index) => 
            {
                if(item.value === props.data.yoil){
                    setGubun(item);
                }
            })
            if(props.data.yoil === '휴일'){
                setOffDayShow(true)
            }else{
                setOffDayShow(false)
            }
            if(props.data.off_day){
                setStartDate(moment(props.data.off_day).toDate());
            }
            setStartTime1(props.data.open.substring(0,2));
            setStartTime2(props.data.open.substring(3,5));
            setEndTime1(props.data.close.substring(0,2));
            setEndTime2(props.data.close.substring(3,5));
            props.data.state === "Y" ? setState(options[0]) : setState(options[1])
        }else{
            alert("정상적인 접근이 아닙니다.")
        }
    },[]);

    return(
        <div className="popup">
            <Draggable handle=".handle">
            <div className="popupInner">
            <div className="handle">
            <h3>{title}</h3>
            <FontAwesomeIcon icon={faTimes} onClick={() => props.closePopup("")} className="closeIcon" />
            </div>
            <Table>
            <tbody>
                <tr>
                    <td style={{width: '160px'}}>센터명</td>
                    <td className="td-select"><SelectCenter onSelectedCenter={handleSelectedCenter} defaultValue={cid} width="w-100"/></td>
                </tr>
                <tr>
                    <td>구분</td>
                    <td>
                    <Select
                        name="gubun"
                        value={gubun}
                        onChange={handleGubunChange}
                        options= {gubunOptions}
                    />
                    </td>
                </tr>
                {
                    offDayShow ? 
                    <tr>
                        <td>휴일</td>
                        <td>
                            <DatePicker
                            selected = {startDate}
                            onChange={handleStartChange}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            locale="ko"
                            showYearDropdown
                            />
                            <ButtonStyle mode="minus" title="-1일" buttonClick={() => handleStartDateMinus()}/>
                            <ButtonStyle mode="plus" title="+1일" buttonClick={() => handleStartDatePlus()}/>
                        </td>
                    </tr>
                    :
                    <>
                    <tr>
                        <td>시작시간</td>
                        <td>
                        {/* <Form.Control type="time" value={startTime} onChange={(e)=> setStartTime(e.target.value)} style={{width:'150px', display:'inline-block'}}/> */}
                        <Form.Control type="text" value={startTime1} onChange={(e)=> setStartTime1(e.target.value)} style={{width:'100px', display:'inline-block'}} placeholder="시"/>
                        &nbsp; : &nbsp;
                        <Form.Control type="text" value={startTime2} onChange={(e)=> setStartTime2(e.target.value)} style={{width:'100px', display:'inline-block'}} placeholder="분"/>
                        </td>
                    </tr>
                    <tr>
                        <td>종료시간</td>
                        <td>
                        {/* <Form.Control type="time" value={endTime} onChange={(e)=> setEndTime(e.target.value)} style={{width:'150px', display:'inline-block'}}/> */}
                        <Form.Control type="text" value={endTime1} onChange={(e)=> setEndTime1(e.target.value)} style={{width:'100px', display:'inline-block'}} placeholder="시"/>
                        &nbsp; : &nbsp;
                        <Form.Control type="text" value={endTime2} onChange={(e)=> setEndTime2(e.target.value)} style={{width:'100px', display:'inline-block'}} placeholder="분"/>
                        </td>
                    </tr>
                    </>
                }
                <tr>
                    <td>상태</td>
                    <td>
                    <Select
                        name="state"
                        value={state}
                        onChange={handleStateChange}
                        options= {options}
                    />
                    </td>
                </tr>
            </tbody>
            </Table>
            {props.mode === "add" || props.mode === "addClient" ? 
            <div className="text-right mr-auto">
            <ButtonStyle mode="add" title="추가" buttonClick={() => handleSubmit()}/>
            </div>
            :
            <div className="text-center mr-auto">
            <ButtonStyle mode="add" title="복사" buttonClick={() => handleSubmit()}/>
            <ButtonStyle mode="edit" title="수정" buttonClick={() => handleEdit()}/>
            <ButtonStyle mode="delete" title="삭제" buttonClick={() => handleDelete()}/>
            </div>
            }
            </div>
            </Draggable>
        </div>
    )
}

export default NewGatePopup;
